module.exports = ".mat-table-container {\n  overflow: auto; }\n\ntable[td-data-table] .td-data-table-cell, table[td-data-table] .td-data-table-column {\n  padding: 0 16px; }\n\ntr.td-data-table-row {\n  height: 80px; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/motivosconsulta/motivosconsulta.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/motivosconsulta/motivosconsulta.component.scss
// module chunks = main